// Custom Cookie Consent Bar integrated with Shopify Customer Privacy API
(function() {
  'use strict';

  // Show cookie consent bar
  function showCookieConsent() {
    const consentBar = document.getElementById('cookie-consent-bar');
    if (consentBar) {
      consentBar.style.display = 'block';
      // Trigger animation
      setTimeout(() => {
        consentBar.classList.add('active');
      }, 100);
    }
  }

  // Hide cookie consent bar
  function hideCookieConsent() {
    const consentBar = document.getElementById('cookie-consent-bar');
    if (consentBar) {
      consentBar.classList.remove('active');
      setTimeout(() => {
        consentBar.style.display = 'none';
      }, 300);
    }
  }

  // Accept cookies using Shopify API
  function acceptCookies() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      // Set tracking consent to accepted
      window.Shopify.customerPrivacy.setTrackingConsent(true, () => {
        hideCookieConsent();
      });
    } else {
      // Fallback if Shopify API is not available
      hideCookieConsent();
    }
  }

  // Decline cookies using Shopify API
  function declineCookies() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      // Set tracking consent to declined
      window.Shopify.customerPrivacy.setTrackingConsent(false, () => {
        hideCookieConsent();
      });
    } else {
      // Fallback if Shopify API is not available
      hideCookieConsent();
    }
  }

  // Check if consent is required
  function checkConsentRequired() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      // Use Shopify's API to check if consent is required
      const shouldShowBanner = window.Shopify.customerPrivacy.shouldShowGDPRBanner();

      if (shouldShowBanner) {
        showCookieConsent();
      }
    } else {
      // Fallback: show banner if Shopify API not available
      // You can add your own logic here to check if consent was given
      showCookieConsent();
    }
  }

  // Initialize
  function init() {
    // Wait for Shopify Customer Privacy API to load
    if (window.Shopify && window.Shopify.customerPrivacy) {
      checkConsentRequired();
    } else {
      // Wait for the API to become available
      const checkInterval = setInterval(() => {
        if (window.Shopify && window.Shopify.customerPrivacy) {
          clearInterval(checkInterval);
          checkConsentRequired();
        }
      }, 100);

      // Timeout after 5 seconds
      setTimeout(() => {
        clearInterval(checkInterval);
        // Show banner anyway if API doesn't load
        checkConsentRequired();
      }, 5000);
    }

    // Add event listeners
    const acceptBtn = document.getElementById('cookie-accept-btn');
    const declineBtn = document.getElementById('cookie-decline-btn');

    if (acceptBtn) {
      acceptBtn.addEventListener('click', acceptCookies);
    }

    if (declineBtn) {
      declineBtn.addEventListener('click', declineCookies);
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
